/* DiVAS theme — light interactions */
function setGalleryIndex(i) {
  var thumbs = document.querySelectorAll('[data-pthumb]');
  if (!thumbs.length) return;
  var target = thumbs[i];
  if (!target) return;
  var main = document.querySelector('[data-pmain]');
  if (main && target.dataset.pthumb) main.src = target.dataset.pthumb;
  thumbs.forEach(function (t) { t.classList.toggle('is-active', t === target); });
  if (target.scrollIntoView) target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
}

document.addEventListener('click', function (e) {

  /* mobile nav */
  var navToggle = e.target.closest('[data-nav-toggle]');
  if (navToggle) {
    var nav = document.querySelector('[data-nav]');
    if (nav) {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    return;
  }

  /* hero video — click to play */
  var heroPlay = e.target.closest('[data-hero-play]');
  if (heroPlay) {
    var wrap = heroPlay.closest('[data-hero-video]');
    var video = wrap && wrap.querySelector('video');
    if (video) {
      wrap.classList.add('is-playing');
      video.play();
    }
    return;
  }

  /* product gallery thumbnails */
  var thumb = e.target.closest('[data-pthumb]');
  if (thumb) {
    setGalleryIndex(parseInt(thumb.dataset.pindex || '0', 10));
    return;
  }
  /* product gallery prev/next arrows */
  var prevBtn = e.target.closest('[data-pprev]');
  var nextBtn = e.target.closest('[data-pnext]');
  if (prevBtn || nextBtn) {
    var thumbs = document.querySelectorAll('[data-pthumb]');
    if (!thumbs.length) return;
    var active = document.querySelector('[data-pthumb].is-active');
    var cur = active ? parseInt(active.dataset.pindex || '0', 10) : 0;
    var next = prevBtn ? (cur - 1 + thumbs.length) % thumbs.length : (cur + 1) % thumbs.length;
    setGalleryIndex(next);
    return;
  }

  /* tabs */
  var tabBtn = e.target.closest('[data-tab]');
  if (tabBtn) {
    var root = tabBtn.closest('[data-tabs]');
    if (root) {
      var id = tabBtn.dataset.tab;
      root.querySelectorAll('[data-tab]').forEach(function (b) {
        b.classList.toggle('is-active', b === tabBtn);
      });
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.panel === id);
      });
    }
    return;
  }

  /* accordion */
  var accQ = e.target.closest('[data-acc]');
  if (accQ) {
    var open = accQ.parentElement.classList.toggle('is-open');
    /* a11y: a kepernyoolvaso is tudja, hogy nyitva van-e (Codex QA 2026-08-25) */
    accQ.setAttribute('aria-expanded', open ? 'true' : 'false');
    return;
  }

  /* mobile filters toggle */
  var fToggle = e.target.closest('[data-filters-toggle]');
  if (fToggle) {
    var filters = document.querySelector('[data-filters]');
    if (filters) {
      var fOpen = filters.classList.toggle('is-open');
      fToggle.setAttribute('aria-expanded', fOpen ? 'true' : 'false');
    }
  }
});

/* collection: auto-submit on sort or filter change */
document.addEventListener('change', function (e) {
  var form = e.target.closest('[data-filter-form]');
  if (form) form.submit();
});

/* carousel — pageable track with arrows + dots */
function initCarousel(root) {
  var track = root.querySelector('[data-track]');
  var prev = root.querySelector('[data-prev]');
  var next = root.querySelector('[data-next]');
  var dotsWrap = root.querySelector('[data-dots]');
  if (!track) return;

  function pageW() { return track.clientWidth; }
  function pages() { return Math.max(1, Math.round(track.scrollWidth / pageW())); }
  function current() { return Math.round(track.scrollLeft / pageW()); }

  function update() {
    var cur = current(), n = pages();
    if (dotsWrap) {
      [].forEach.call(dotsWrap.children, function (d, i) {
        d.classList.toggle('is-active', i === cur);
      });
      dotsWrap.style.display = n <= 1 ? 'none' : '';
    }
    if (prev) { prev.disabled = cur <= 0; prev.style.display = n <= 1 ? 'none' : ''; }
    if (next) { next.disabled = cur >= n - 1; next.style.display = n <= 1 ? 'none' : ''; }
  }

  function buildDots() {
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (i + 1) + '. oldal');
        (function (idx) {
          b.addEventListener('click', function () {
            track.scrollTo({ left: idx * pageW(), behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(b);
      }
    }
    update();
  }

  if (prev) prev.addEventListener('click', function () {
    track.scrollBy({ left: -pageW(), behavior: 'smooth' });
  });
  if (next) next.addEventListener('click', function () {
    track.scrollBy({ left: pageW(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', update);
  window.addEventListener('resize', buildDots);
  buildDots();
}
document.querySelectorAll('[data-carousel]').forEach(initCarousel);


/* --- DiVAS lightbox --- */
(function () {
  var lb, img, counter, idx = 0, zoom = 1, ox = 0, oy = 0, customList = null;

  function slides() {
    if (customList) return customList;
    /* csak a KÉPEK kerülnek a nagyítóba; a videó marad a galériában */
    var imgs = [].filter.call(document.querySelectorAll('[data-pthumb]'), function (t) {
      return (t.dataset.ptype || 'image') === 'image';
    });
    return imgs.map(function (t) {
      return {
        src: t.dataset.pfull || t.dataset.pthumb,
        alt: t.dataset.palt || '',
        gindex: parseInt(t.dataset.pindex || '0', 10)
      };
    });
  }

  function build() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'plb';
    lb.innerHTML =
      '<div class="plb__stage" data-plb-stage><img class="plb__img" data-plb-img alt=""></div>' +
      '<button class="plb__close" type="button" data-plb-close aria-label="Bezárás">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<button class="plb__nav plb__nav--prev" type="button" data-plb-prev aria-label="Előző kép">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
      '<button class="plb__nav plb__nav--next" type="button" data-plb-next aria-label="Következő kép">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' +
      '<div class="plb__counter" data-plb-counter></div>';
    document.body.appendChild(lb);
    img = lb.querySelector('[data-plb-img]');
    counter = lb.querySelector('[data-plb-counter]');
    wire();
    return lb;
  }

  function applyZoom() {
    img.style.transform = 'scale(' + zoom + ') translate(' + ox + 'px,' + oy + 'px)';
    lb.classList.toggle('is-zoomed', zoom > 1);
  }

  function resetZoom() { zoom = 1; ox = 0; oy = 0; applyZoom(); }

  function show(i) {
    var list = slides();
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    img.src = list[idx].src;
    img.alt = list[idx].alt;
    counter.textContent = (idx + 1) + ' / ' + list.length;
    var multi = list.length > 1;
    lb.querySelector('[data-plb-prev]').style.display = multi ? '' : 'none';
    lb.querySelector('[data-plb-next]').style.display = multi ? '' : 'none';
    counter.style.display = multi ? '' : 'none';
    resetZoom();
  }

  function open(i) {
    customList = null;
    build();
    lb.classList.add('is-open');
    document.body.classList.add('plb-lock');
    show(i);
  }

  function close() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.classList.remove('plb-lock');
    resetZoom();
  }

  function wire() {
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-plb-close]')) { close(); return; }
      if (e.target.closest('[data-plb-prev]')) { show(idx - 1); return; }
      if (e.target.closest('[data-plb-next]')) { show(idx + 1); return; }
      if (e.target === img) {
        if (zoom > 1) { resetZoom(); } else { zoom = 2.5; applyZoom(); }
        return;
      }
      close();
    });

    /* görgővel is lehet nagyítani */
    lb.addEventListener('wheel', function (e) {
      if (!lb.classList.contains('is-open')) return;
      e.preventDefault();
      zoom = Math.min(5, Math.max(1, zoom + (e.deltaY < 0 ? 0.3 : -0.3)));
      if (zoom === 1) { ox = 0; oy = 0; }
      applyZoom();
    }, { passive: false });

    /* húzás nagyított állapotban (egér + érintés) */
    var dragging = false, sx = 0, sy = 0, bx = 0, by = 0;
    function down(x, y) {
      if (zoom <= 1) return;
      dragging = true; sx = x; sy = y; bx = ox; by = oy;
      lb.classList.add('is-panning');
    }
    function move(x, y) {
      if (!dragging) return;
      ox = bx + (x - sx) / zoom;
      oy = by + (y - sy) / zoom;
      applyZoom();
    }
    function up() { dragging = false; lb.classList.remove('is-panning'); }

    img.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', up);

    var pinch0 = 0, zoom0 = 1;
    img.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinch0 = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                            e.touches[0].clientY - e.touches[1].clientY);
        zoom0 = zoom;
      } else if (e.touches.length === 1) {
        down(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });
    img.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinch0) {
        e.preventDefault();
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                           e.touches[0].clientY - e.touches[1].clientY);
        zoom = Math.min(5, Math.max(1, zoom0 * (d / pinch0)));
        if (zoom === 1) { ox = 0; oy = 0; }
        applyZoom();
      } else if (e.touches.length === 1 && dragging) {
        e.preventDefault();
        move(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: false });
    img.addEventListener('touchend', function () { pinch0 = 0; up(); }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* külső hívás: tetszőleges képlistával (pl. szövetminták) */
  window.divasLightbox = function (list, i) {
    customList = list && list.length ? list : null;
    build();
    lb.classList.add('is-open');
    document.body.classList.add('plb-lock');
    show(i || 0);
  };

  /* megnyitás: az aktív slide képére vagy a nagyító gombra kattintva */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pzoom]');
    if (!trigger && e.target.matches && e.target.matches('.pgallery__slide.is-active img[data-pfull]')) {
      trigger = e.target;
    }
    if (!trigger) return;
    var active = document.querySelector('[data-pthumb].is-active');
    if (active && (active.dataset.ptype || 'image') !== 'image') return;   /* videó: nincs nagyítás */
    var gi = active ? parseInt(active.dataset.pindex || '0', 10) : 0;
    var list = slides(), pos = 0;
    for (var k = 0; k < list.length; k++) { if (list[k].gindex === gi) { pos = k; break; } }
    open(pos);
  });
})();


/* --- DiVAS galéria: videó-támogatás --- */
(function () {
  /* A galéria már nem egyetlen <img>-et cserél, hanem slide-okat kapcsol,
     mert videót nem lehet src-cserével megjeleníteni. */
  function stopMedia(slide) {
    if (!slide) return;
    var v = slide.querySelector('video');
    if (v && !v.paused) v.pause();
    var f = slide.querySelector('iframe');
    if (f) f.src = f.src;                     /* YouTube/Vimeo leállítása */
  }

  window.setGalleryIndex = function (i) {
    var thumbs = document.querySelectorAll('[data-pthumb]');
    if (!thumbs.length) return;
    var target = thumbs[i];
    if (!target) return;
    var gallery = document.querySelector('[data-pgallery]');
    var slides = document.querySelectorAll('[data-pslide]');
    [].forEach.call(slides, function (s) {
      var on = s.dataset.pslide === String(i);
      if (!on && s.classList.contains('is-active')) stopMedia(s);
      s.classList.toggle('is-active', on);
    });
    [].forEach.call(thumbs, function (t) { t.classList.toggle('is-active', t === target); });
    if (gallery) {
      gallery.classList.toggle('is-video', (target.dataset.ptype || 'image') !== 'image');
    }
    if (target.scrollIntoView) target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  /* induláskor az első elem típusa szerint állítsuk a nagyító láthatóságát */
  document.addEventListener('DOMContentLoaded', function () {
    var first = document.querySelector('[data-pthumb]');
    var gallery = document.querySelector('[data-pgallery]');
    if (first && gallery) {
      gallery.classList.toggle('is-video', (first.dataset.ptype || 'image') !== 'image');
    }
  });
})();


/* --- DiVAS: szövetminta nagyítás --- */
(function () {
  /* A színmintára kattintva ugyanaz a nagyító nyíljon meg, mint a termékképeknél.
     A `window.divasLightbox` a fix_gallery_zoom.py lightboxából jön. */
  document.addEventListener('click', function (e) {
    var img = e.target.closest('[data-pswatch]');
    if (!img || !window.divasLightbox) return;
    var wrap = img.closest('.fabric-swatches') || document;
    var all = [].map.call(wrap.querySelectorAll('[data-pswatch]'), function (n) {
      return { src: n.dataset.pswatch, alt: n.dataset.palt || n.alt || '' };
    });
    var pos = [].indexOf.call(wrap.querySelectorAll('[data-pswatch]'), img);
    window.divasLightbox(all, pos < 0 ? 0 : pos);
  });
})();

/* === referencia-galeria lightbox (referenciak/tema.py) === */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.refgal a[data-full]');
    if (!a || typeof window.divasLightbox !== 'function') return;
    e.preventDefault();
    var gal = a.closest('.refgal');
    var linkek = Array.prototype.slice.call(gal.querySelectorAll('a[data-full]'));
    var lista = linkek.map(function (x) { return { src: x.getAttribute('data-full'), alt: x.getAttribute('data-palt') || '' }; });
    window.divasLightbox(lista, linkek.indexOf(a));
  });
})();
/* === referencia-galeria lightbox vege === */


/* ---- Időpontfoglaló modál (TimeBeeZ) --------------------------------------
   A widget iframe-be a srcdoc CSAK nyitáskor kerül be, hogy a külső script ne
   fusson feleslegesen minden oldalbetöltésnél. */
(function () {
  function nyit(m) {
    var f = m.querySelector('[data-tb-frame]');
    if (f && !f.getAttribute('srcdoc')) f.setAttribute('srcdoc', f.getAttribute('data-src') || '');
    m.hidden = false;
    document.body.classList.add('tb-open');
    var c = m.querySelector('.tb-modal__close'); if (c) c.focus();
  }
  function zar(m) { m.hidden = true; document.body.classList.remove('tb-open'); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-tb-open]');
    if (o) { var m = document.getElementById(o.getAttribute('data-tb-open')); if (m) { e.preventDefault(); nyit(m); } return; }
    var c = e.target.closest && e.target.closest('[data-tb-close]');
    if (c) { var mm = c.closest('[data-tb-modal]'); if (mm) zar(mm); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-tb-modal]').forEach(function (m) { if (!m.hidden) zar(m); });
  });
})();
